import _import from './config'
export default {
    path: 'system',
    component: {
        template: '<router-view :key="$route.fullPath"/>'
    },
    name: 'system',
    redirect: '/system/organization',
    children: [
        {
            path: 'organization',
            component: {
                template: '<router-view :key="$route.fullPath"/>'
            },
            name: 'organization',
            redirect: '/system/organization/construction',
            children: [
                {
                    path: 'construction',
                    component: _import('system/organization/construction'),
                    name: 'construction',
                    meta: {
                        auth: true
                    }
                }, {
                    path: 'role',
                    component: _import('system/organization/role'),
                    name: 'role',
                    meta: {
                        auth: true
                    }
                }, {
                    path: 'employee',
                    component: _import('system/organization/employee'),
                    name: 'employee',
                    meta: {
                        auth: true
                    }
                }, {
                    path: 'userposition',
                    component: _import('system/organization/userposition'),
                    name: 'userposition',
                    meta: {
                        auth: true
                    }
                }, {
                    path: 'subjectgroup',
                    component: {
                        template: '<router-view :key="$route.fullPath"/>'
                    },
                    name: 'subjectgroup',
                    redirect: '/system/organization/subjectgroup/subgroup',
                    children: [
                        {
                            path: 'subgroup',
                            component: _import('system/organization/subjectgroup/group'),
                            name: 'subgroup',
                            meta: {
                                auth: true
                            }
                        }
                    ]
                }
            ]
        }, {
            path: 'metadata',
            component: {
                template: '<router-view :key="$route.fullPath"/>'
            },
            name: 'metadata',
            redirect: '/system/metadata/pc',
            children: [
                {
                    path: 'menu/pc',
                    component: _import('system/metadata/menu'),
                    name: 'pcMenu',
                    meta: {
                        auth: true
                    }
                }, {
                    path: 'menu/app',
                    component: _import('system/metadata/menu'),
                    name: 'appMenu',
                    meta: {
                        auth: true
                    }
                }, {
                    path: 'kinship',
                    component: _import('system/metadata/kinShip'),
                    name: 'kinship',
                    meta: {
                        auth: true
                    }
                }, {
                    path: 'source',
                    component: _import('system/metadata/Source'),
                    name: 'source',
                    meta: {
                        auth: true
                    }
                }, {
                    path: 'position',
                    component: _import('system/metadata/position'),
                    name: 'position',
                    meta: {
                        auth: true
                    }
                }, {
                    path: 'grade',
                    component: _import('system/metadata/Grade'),
                    name: 'grade',
                    meta: {
                        auth: true
                    }
                }, {
                    path: 'invalidReason',
                    component: _import('system/metadata/invalidReason'),
                    name: 'invalidReason',
                    meta: {
                        auth: true
                    }
                }, {
                    path: 'kanbanBoard',
                    component: _import('system/metadata/kanbanBoard'),
                    name: 'kanbanBoard',
                    meta: {
                        auth: true
                    }
                }, {
                    path: 'production',
                    component: _import('system/metadata/production'),
                    name: 'production',
                    meta: {
                        auth: true
                    }
                }, {
                    path: 'school',
                    component: _import('system/metadata/school'),
                    name: 'school',
                    meta: {
                        auth: true
                    }
                }, {
                    path: 'constant',
                    component: _import('system/metadata/constant'),
                    name: 'constant',
                    meta: {
                        auth: true
                    }
                }, {
                    path: 'modelAgreement',
                    component: _import('system/metadata/modelAgreement'),
                    name: 'modelAgreement',
                    meta: {
                        auth: true
                    }
                }, {
                    path: 'signet',
                    component: _import('system/metadata/signet'),
                    name: 'signet',
                    meta: {
                        auth: true
                    }
                }, {
                    path: 'logo',
                    component: _import('system/metadata/logo'),
                    name: 'logo',
                    meta: {
                        auth: true
                    }
                }, {
                    path: 'paymethod',
                    component: _import('system/metadata/paymethod'),
                    name: 'paymethod',
                    meta: {
                        auth: true
                    }
                }, {
                    path: 'subject',
                    component: _import('system/metadata/subject'),
                    name: 'subject',
                    meta: {
                        auth: true
                    }
                }, {
                    path: 'scoresubject',
                    component: _import('system/metadata/scoreSubject'),
                    name: 'scoresubject',
                    meta: {
                        auth: true
                    }
                }, {
                    path: 'rewards',
                    component: _import('system/metadata/rewardrules'),
                    name: 'rewards',
                    meta: {
                        auth: true
                    }
                }, {
                    path: 'message',
                    component: _import('system/metadata/pushMessage'),
                    name: 'message',
                    meta: {
                        auth: true
                    }
                }, {
                    path: 'messagetemplate',
                    component: _import('system/metadata/Messagetemplate'),
                    name: 'messagetemplate',
                    meta: {
                        auth: true
                    }
                }
            ]
        }, {
            path: 'else',
            component: {
                template: '<router-view :key="$route.fullPath"/>'
            },
            name: 'else',
            redirect: '/system/else/question',
            children: [
                {
                    path: 'question',
                    component: _import('system/else/question'),
                    name: 'question',
                    meta: {
                        auth: true
                    }
                }, {
                    path: 'shortmsg',
                    component: _import('system/else/shortmsg'),
                    name: 'shortmsg',
                    meta: {
                        auth: true
                    }
                }
            ]
        }, {
            path: 'app',
            component: {
                template: '<router-view :key="$route.fullPath"/>'
            },
            name: 'app',
            redirect: '/system/app/version',
            children: [
                {
                    path: 'version',
                    component: _import('system/app/version'),
                    name: 'version',
                    meta: {
                        auth: true
                    }
                }
            ]
        }, {
            path: 'pc/version',
            component: _import('system/pc/versionPc'),
            name: 'pcversion',
            meta: {
                auth: true
            },
        }, {
            path: 'activityList',
            component: _import('system/activityList'),
            name: 'activityList',
            meta: {
                auth: true
            }
        }, {
            path: 'activeticket',
            component: _import('system/activityTicket'),
            name: 'activeticket',
            meta: {
                auth: true
            }
        }, {
            path: 'tags',
            component: _import('system/tagsManage'),
            name: 'tags',
            meta: {
                auth: true
            }
        }, {
            path: 'schedule',
            component: _import('system/schedule'),
            name: 'schedule',
            meta: {
                auth: true
            }
        }, {
            path: 'products',
            component: {
                template: '<router-view :key="$route.fullPath"/>'
            },
            name: 'products',
            redirect: '/system/products/productList',
            children: [
                {
                    path: 'classtype',
                    component: _import('system/products/classType'),
                    name: 'classtype',
                    meta: {
                        auth: true
                    }
                }, {
                    path: 'productList',
                    component: _import('system/products/productList'),
                    name: 'productList',
                    meta: {
                        auth: true
                    }
                }
            ]
        }, {
            path: 'approval',
            component: {
                template: '<router-view :key="$route.fullPath"/>'
            },
            name: 'approval',
            redirect: '/system/approval/typelist',
            children: [
                {
                    path: 'typelist',
                    component: _import('system/approval/typelist'),
                    name: 'typelist',
                    meta: {
                        auth: true
                    }
                }
            ]
        }, {
            path: 'approval-all',
            component: _import('system/approves'),
            name: 'approval-all',
            meta: {
                auth: true
            }
        }
    ]
}


// WEBPACK FOOTER //
// ./src/router/system.js